import { CookieStorage } from 'cookie-storage';

const cookieStorage = new CookieStorage();
const clientId = "ddcd4fe8157148fc90b0fe95753f2bd0";
const cropwiseBaseAPIUrl = "staging.accounts.cropwise.com";
const env = "dev";

export const isAccessTokenAvailable = () => !!localStorage.getItem('tokens');
export const setAccessToken = tokens => localStorage.setItem('tokens', tokens);
export const getTokens = () => localStorage.getItem('tokens') || '{}';
export const clearAccessToken = () => {
  window.indexedDB.deleteDatabase('cwf-cache');
  localStorage.clear();
};

export const getAccessToken = () => JSON.parse(getTokens()).access_token;

export const accountsOAuthUrl = `https://${cropwiseBaseAPIUrl}
/oauth/authorize
?response_type=code
&client_id=${clientId}
&redirect_uri=${window.location.origin}/authenticate`;

export const cleanNewUserSession = () => {
  const key = `resetUserSession_${env}`;

  if (cookieStorage.getItem(key)) {
    clearAccessToken();
    document.cookie = `${key}= ; domain=cropwise.com; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
    window.location.href = accountsOAuthUrl;
  }
};
